export default __webpack_public_path__ + "static/media/banner.ab31f758.jpg";